<template>
  <VOverlay :model-value="show" class="flex justify-center items-center">
    <VCard class="p-6 flex flex-col gap-4 !rounded-2xl w-[343px] md:w-[400px]">
      <VCardTitle class="p-0">
        <div class="flex items-center font-semibold justify-between text-base">
          <p>{{ t('Enable push notifications') }}</p>

          <VIcon :color="'grey-400'" icon="close" @click="emit('close')" />
        </div>
      </VCardTitle>

      <VCardItem class="p-0">
        <div class="flex flex-col gap-6 text-gray-600">
          <p>
            {{
              t(
                'Enable push notifications to get updates for consultation requests and status changes'
              ) + '.'
            }}
          </p>

          <div class="flex items-center gap-2">
            <input
              :checked="checkboxValue"
              :style="{ '--v-border-opacity': '1' }"
              data-testid="prevent-display-checkbox"
              class="custom-checkbox appearance-none w-4 h-4 rounded border border-grey-300 cursor-pointer flex items-center justify-center checked:bg-primary checked:!border-primary"
              type="checkbox"
              @click="onCheck"
            />

            <p class="text-sm text-gray-700">
              {{ t('Never show this notification prompt again') }}
            </p>
          </div>
        </div>
      </VCardItem>

      <VCardActions class="p-0 min-h-0 flex flex-col md:flex-row">
        <VBtn
          :text="t('Not now')"
          :variant="'outlined'"
          :color="'secondary-700'"
          data-testid="close-button"
          :class="[
            'font-semibold border-grey-300 text-base py-2 !h-fit w-full md:w-auto',
            { 'flex-1': locale === 'en' }
          ]"
          @click="emit('close')"
        />

        <VBtn
          :text="t('Enable notifications')"
          :variant="'flat'"
          :color="'primary'"
          :class="['font-semibold text-base py-2 !h-fit flex-1 w-full']"
          data-testid="enable-notifications-button"
          @click="emit('enable-notifications-click')"
        />
      </VCardActions>
    </VCard>
  </VOverlay>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

interface Props {
  show: boolean
}

interface Emits {
  (e: 'close'): void
  (e: 'enable-notifications-click'): void
  (e: 'prevent-popup-display', value: boolean): void
}

const checkboxValue = ref<boolean>(false)
const { t, locale } = useI18n()

defineProps<Props>()
const emit = defineEmits<Emits>()

function onCheck(): void {
  checkboxValue.value = !checkboxValue.value
  emit('prevent-popup-display', checkboxValue.value)
}
</script>

<style scoped lang="scss">
:deep(.v-selection-control) {
  min-height: unset;
}

:deep(.v-selection-control__wrapper) {
  width: fit-content;
  height: fit-content;

  .v-selection-control__input {
    width: fit-content;
    height: fit-content;
  }
}

.custom-checkbox::after {
  border-color: white;
  border-style: solid;
  border-width: 0 0.15em 0.15em 0;
  box-sizing: border-box;
  content: '';
  aspect-ratio: 1 / 2;
  rotate: 40deg;
  width: 0.35em;
  display: none;
}

.custom-checkbox:checked::after {
  display: block;
}
</style>
